import { createDynamicSlice } from ".";
import { fetchDepartmentsThunk } from "../thunks/departmentsThunk";

export const departmentsSlice = createDynamicSlice({
  name: "departments",
  thunk: fetchDepartmentsThunk,
  listMode: true,
  resetActionName: "resetDepartments",
});

export const departmentsReducer = departmentsSlice.reducer;
export const { resetDepartments } = departmentsSlice.actions;
